export const checkProps = (objToMatch, objToCheck) => {
  // get properties from the object you want to match
  const props = Object.getOwnPropertyNames(objToMatch);
  // make sure that each property exists and matches in the object that is being checked
  return props.every(prop => {
    const valueToMatch = objToMatch[prop];
    const valueToCheck = objToCheck[prop];
    if (typeof valueToMatch !== typeof valueToCheck) {
      return false;
    }
    return typeof valueToMatch === 'object'
      ? checkProps(valueToMatch, valueToCheck)
      : valueToMatch === valueToCheck;
  });
};

export const isActionInList = (action, list) =>
  list.some(listItem => {
    if (typeof listItem === 'string') {
      // for string, match type
      return listItem === action.type;
    }
    if (typeof listItem === 'object') {
      return checkProps(listItem, action);
    }
    return false;
  });

const removeFromObject = (itemToRemove, obj) =>
  Object.keys(obj).reduce(
    (acc, curr) =>
      curr !== itemToRemove ? { ...acc, [curr]: obj[curr] } : acc,
    {}
  );

export default (config = {}) => (state = {}, action = {}) => {
  // if there is no sequence data, we can't track start/finish
  if (!action.sequence) {
    return state;
  }

  // extract include/exclude lists from config
  const defaultConfig = {};
  const { includeActions = [], excludeActions = [] } = config || defaultConfig;

  // determine if a special sequence type has been dispatched
  const specialSequenceDispatched = includeActions.some(includeAction => {
    if (includeAction.sequence && includeAction.sequence.type) {
      return includeAction.sequence.type === action.sequence.type;
    }
    return false;
  });

  if ((action.sequence && action.sequence.type === 'start') || specialSequenceDispatched) {
    // if there are no includes, assume all should be caught
    const isIncluded = includeActions.length
      ? isActionInList(action, includeActions)
      : true;
    // if there are no excludes, assume none should be excluded
    const isExcluded = excludeActions.length
      ? isActionInList(action, excludeActions)
      : false;

    if (isIncluded && !isExcluded) {
      return Object.assign({}, state, {
        [action.type]: Object.assign({}, state[action.type], {
          [action.sequence.id]: action.meta || {},
        }),
      });
    }
  }
  // if the 'next' action was dispatched, the request has finished
  if (action.sequence && action.sequence.type === 'next') {
    if (state[action.type]) {
      const savedActionIds = Object.keys(state[action.type]) || [];
      // if the action type has more ids than the one being removed
      if (savedActionIds.filter(id => id !== action.sequence.id).length) {
        // remove the id from the action type
        return Object.assign({}, state, {
          [action.type]: removeFromObject(
            action.sequence.id.toString(),
            state[action.type]
          ),
        });
      }
      // if the id being removed is the only one on the action, remove the whole action
      return removeFromObject(action.type, state);
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/redux-modules/pending-promises/reducers/index.js